/**
 * RGB to HSL
 * https://css-tricks.com/converting-color-spaces-in-javascript/
 */
 rgbToHsl = (r, g, b) => {
  // Make r, g, and b fractions of 1
  r /= 255;
  g /= 255;
  b /= 255;

  // Find greatest and smallest channel values
  let cmin = Math.min(r,g,b),
      cmax = Math.max(r,g,b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;
  
  // Calculate hue
  // No difference
  if (delta == 0)
    h = 0;
  // Red is max
  else if (cmax == r)
    h = ((g - b) / delta) % 6;
  // Green is max
  else if (cmax == g)
    h = (b - r) / delta + 2;
  // Blue is max
  else
    h = (r - g) / delta + 4;

  h = Math.round(h * 60);
    
  // Make negative hues positive behind 360°
  if (h < 0)
      h += 360;
  
  // Calculate lightness
  l = (cmax + cmin) / 2;

  // Calculate saturation
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    
  // Multiply l and s by 100
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  // return "hsl(" + h + "," + s + "%," + l + "%)";
  return [h, s, l];
}


const container = document.querySelector('.home');
if (container) {
let bgColor = getComputedStyle(container);
bgColor = bgColor.backgroundColor.replace(/[()rgba ]/g,"").split(",");
const hsl = rgbToHsl(bgColor[0], bgColor[1], bgColor[2]),
      degree = 8;

let scrollHeight = Math.max(
  document.body.scrollHeight, document.documentElement.scrollHeight,
  document.body.offsetHeight, document.documentElement.offsetHeight,
  document.body.clientHeight, document.documentElement.clientHeight
);

if (window.matchMedia && window.matchMedia('(max-device-width: 767px)').matches)  {
  // デバイス幅767以下の時、背景グラデーション値
  colorValue = 360
} else if (window.matchMedia && window.matchMedia('(min-device-width: 768px)').matches)  {
  // デバイス幅768以上の時、背景グラデーション値
  colorValue = 290
}
window.addEventListener('scroll', () => {
  let point = Math.round(window.pageYOffset / scrollHeight * `${colorValue}`)
  if (point > 255) {
    point = 255
  }
  bgColor[0] = point
  bgColor[1] = point
  bgColor[2] = point
  // let y = (window.scrollY || window.pageYOffset) / 100;
  // y = y < 0 ? 0 : y; // ensure y is always >= 0 (due to Safari's elastic scroll)
  
  // const hue = hsl[0] + y * degree,
  //       [h, s, l] = [hue, hsl[1], hsl[2]];

  // container.style.backgroundColor = `hsl(${h}, ${s}%, ${l}%)`;
  container.style.backgroundColor = `rgb(${bgColor[0]},${bgColor[1]},${bgColor[2]})`;
  if (window.pageYOffset > 600) {
    document.getElementById('Topmenu').classList.add('visible')
    document.getElementById('topLogo').classList.add('visible')
  } else {
    document.getElementById('Topmenu').classList.remove('visible')
    document.getElementById('topLogo').classList.remove('visible')
  }
});
}

// ナビメニュー開閉
$(function(){
  $('.menu-btn').on('click', function(){
    $('.menu-wrap').toggleClass('is-active');
  });
}());

// ハンバーガーメニュー開閉ボタンアクション
$(".menu-btn").click(function () {
  $(this).toggleClass('active');
});


const mouse = $(".mouse");
 
function Cursor(element, options) {
  function stringNode(node) {
    var tmpNode = document.createElement("div");
    tmpNode.appendChild(node.cloneNode(true));
    return tmpNode.innerHTML;
  }
 
  var intSize = parseInt(options.size);
  function setSize(size, scale) {
    if (scale) {
      scale = `${scale}`;
      element.css({
        "transform" : `scale(${options.hoverSize})`,
        "opacity" : ".6"
      });
    } else {
      size = parseInt(size);
      element.css({
        width: size + "px",
        height: size + "px",
        transform: "none",
        opacity : "0.7"
      });
    }
  }
 
  setSize(options.size);
 
  document.onmousemove = e => {
    element.css({
      left: e.clientX - parseInt(options.size) / 2 + "px",
      top: e.clientY - parseInt(options.size) / 2 + "px"
    });
    elementType = stringNode(e.target)
      .replace(/\</g, "")
      .split(">")[0]
      .split(" ")[0];
    //console.log(elementType)
    if (["a", "button", "input"].includes(elementType))
      setSize(options.size, options.hoverSize);
    else setSize(options.size);
  };
}
 
Cursor(mouse, {
  size: "10px", // Width and Height
  hoverSize: 1.4 // Scale size
});
